import { call, put, takeEvery } from 'redux-saga/effects'
import { types, IGetMediaTypeGroupsAction } from '../types/mediaTypeGroups'
import * as actions from '../actions/mediaTypesGroups'
import * as services from '../services/mediaTypeGroups'
import { trace } from '../services/common'

export function* getMediaTypeGroupsSaga(action: IGetMediaTypeGroupsAction) {
  try {
    const list = yield call(services.getMediaTypeGroups)
    yield put(actions.getMediaTypeGroupsSuccess(list))
  } catch (err) {
    trace(err)
    yield put(actions.getMediaTypeGroupsFailure(err.message))
  }
}

export function* mediaTypeGroupsWatcher() {
  yield takeEvery(types.GET_MEDIA_TYPE_GROUPS__STARTED, getMediaTypeGroupsSaga)
}
